export default {
  // ページタイトル
  title: '活動作成',
  editTitle: '活動編集',
  // ステップタイトル
  step1: '基本情報',
  step2: '活動範囲',
  step3: '活動賞品',
  step4: '活動戦略',
  // ステップ1 - 基本情報
  activityName: '活動名',
  activityNameRequired: '活動名を入力してください',
  activityNamePlaceholder: '活動名を入力してください',
  activityTime: '活動期間',
  activityTimeRequired: '活動期間を選択してください',
  startTime: '開始時間',
  endTime: '終了時間',
  activityTemplate: 'テンプレート',
  activityTemplateRequired: 'テンプレートを選択してください',
  activityTemplatePlaceholder: 'テンプレートを選択してください',
  addTemplate: 'テンプレート追加',
  activityRule: '活動ルール',
  rulePlaceholder: '活動ルールを入力してください',
  activityRemark: '備考',
  remarkPlaceholder: '備考を入力してください',
  // ステップ2 - アクティビティ範囲
  addCode: 'QRコードを追加',
  addCodeTitle: 'QRコードを追加',
  selectCodePlaceholder: 'QRコードを選択してください',
  codeEmptyText: 'QRコードデータがありません',
  codeBatch: 'コードバッチ',
  codeRange: 'QRコード範囲',
  codeCount: 'QRコード数量',
  scopeRemark: '範囲備考',
  colAction: '操作',
  deleteCode: '削除',
  // ステップ3 - アクティビティ賞品
  addPrize: '賞品を追加',
  addPrizeTitle: '賞品を追加',
  editPrizeTitle: '賞品を編集',
  editPrize: '編集',
  deletePrize: '削除',
  confirmDeletePrize: 'この賞品を削除しますか？',
  prizeEmptyText: '賞品データがありません',
  prizeName: '賞品名',
  prizeNameRequired: '賞品名を入力してください',
  prizeNamePlaceholder: '賞品名を入力してください',
  prizeProbability: '当選確率',
  prizeProbabilityPlaceholder: '当選確率を入力してください',
  prizeCount: '賞品数量',
  prizeCountPlaceholder: '賞品数量を入力してください',
  prizeContent: '賞品内容',
  pointsLabel: 'ポイント',
  giftLabel: 'ギフト',
  strategyOnly: '戦略のみ当選',
  prizeImage: '賞品画像',
  prizePoints: 'ポイント',
  prizeGift: 'ギフト名',
  prizeGiftPlaceholder: 'ギフト名を入力してください',
  // ステップ4 - アクティビティ戦略
  addStrategy: '戦略を追加',
  addStrategyTitle: '戦略を追加',
  editStrategyTitle: '戦略を編集',
  editStrategy: '編集',
  deleteStrategy: '削除',
  confirmDeleteStrategy: 'この戦略を削除しますか？',
  strategyEmptyText: '戦略データがありません',
  strategyStatus: '戦略ステータス',
  strategyName: '戦略名',
  strategyNameRequired: '戦略名を入力してください',
  strategyNamePlaceholder: '戦略名を入力してください',
  strategyDetail: '戦略詳細',
  specifyCountry: '指定国/地域',
  specifyCountryPlaceholder: '国/地域を入力してください',
  strategyType: '戦略タイプ',
  strategyRules: '戦略ルール',
  ruleType: 'ルールタイプ',
  ruleContent: 'ルール内容',
  ruleEmptyText: '戦略ルールがありません',
  ruleFormPlaceholder: 'ルール設定は後で追加',
  typeCountry: '指定国/地域で当選',
  typeCountryDesc: '指定した地域またはGPS範囲内のユーザーが当選可能',
  typeMemberLevel: '指定会員レベルで当選',
  typeMemberLevelDesc: '指定した会員レベルのユーザーが当選可能',
  typeUserLimit: 'ユーザー制限当選',
  typeUserLimitDesc: 'アクティビティ期間中、ユーザーは最大N回当選可能',
  typeTimePeriod: '指定時間帯で当選',
  typeTimePeriodDesc: 'アクティビティ期間中、指定した時間帯に当選可能',
  memberLevel: '会員レベル',
  memberLevelPlaceholder: '会員レベルを選択してください',
  countryRegion: '国/地域',
  countryPlaceholder: '国を選択してください',
  regionPlaceholder: '地域を選択してください',
  timePeriod: '時間周期',
  timePeriods: '時間帯',
  currentActivityPeriod: '現在のアクティビティ期間',
  userLimitCount: 'ユーザー累計回数',
  nthLabel: '第',
  scanParticipate: '回スキャン参加',
  prizeProbabilityRequired: '当選確率を入力してください',
  prizeCountRequired: '賞品数量を入力してください',
  prizeContentRequired: '賞品内容を少なくとも1つ選択してください',
  prizeGiftRequired: 'ギフトを選択してください',
  prizePointsRequired: 'ポイント数を入力してください',
  selectGift: 'ギフトを選択',
  giftNameCol: 'ギフト名',
  giftCategoryCol: 'ギフトカテゴリ',
  selectCodeBatch: 'コードバッチを選択',
  codeBatchRequired: 'コードバッチを選択してください',
  codeBatchPlaceholder: 'コードバッチを選択してください',
  codeBatchNo: 'バッチ番号',
  codeBatchName: 'バッチ名',
  codeRangeType: 'QRコード範囲',
  codeRangeTypeRequired: 'QRコード範囲を選択してください',
  rangeAll: 'バッチ全体を追加',
  rangePartial: '部分追加',
  rangePartialSerial: '部分追加（シリアル番号範囲）',
  rangePartialId: '部分追加（ID範囲）',
  codeRangeRequired: 'QRコード範囲を入力してください',
  serialRange: 'シリアル番号範囲',
  idRange: 'QRコードID範囲',
  serialStartPlaceholder: '開始シリアル番号',
  serialEndPlaceholder: '終了シリアル番号',
  idStartPlaceholder: '開始ID',
  idEndPlaceholder: '終了ID',
  rangeStartPlaceholder: '開始番号',
  rangeEndPlaceholder: '終了番号',
  scopeRemarkPlaceholder: '範囲備考を入力してください',
  invalidRange: '終了番号は開始番号より大きい必要があります',
  serialRangeInvalid: '開始シリアル番号は終了シリアル番号より大きくすることはできません',
  confirmDeleteRange: 'この活動範囲を削除しますか？',
  prizeIcon: '賞品アイコン',
  prizeIconRequired: '賞品アイコンをアップロードしてください',
  prizePointsPlaceholder: 'ポイント数を入力してください',
  timeType: '時間タイプ',
  timeTypeDaily: '毎日',
  timeTypeWeekly: '毎週',
  timeTypeCustom: 'カスタム日付範囲',
  selectWeekDays: '曜日を選択',
  selectDateRange: '日付範囲を選択',
  startDate: '開始日',
  endDate: '終了日',
  weekDayMon: '月曜',
  weekDayTue: '火曜',
  weekDayWed: '水曜',
  weekDayThu: '木曜',
  weekDayFri: '金曜',
  weekDaySat: '土曜',
  weekDaySun: '日曜',
};
